const textAndImageBlock = {
  displayField: 'internalName',
  name: 'Text And Image Block',
  description: '',
  fields: [
    {
      id: 'internalName',
      name: 'Internal Name',
      type: 'Symbol',
      localized: false,
      required: false,
      validations: [],
      disabled: false,
      omitted: false
    },
    {
      id: 'eyebrow',
      name: 'Eyebrow',
      type: 'Symbol',
      localized: true,
      required: false,
      validations: [ { size: { min: null, max: 256 } } ],
      disabled: false,
      omitted: false
    },
    {
      id: 'header',
      name: 'Header',
      type: 'Symbol',
      localized: true,
      required: false,
      validations: [ { size: { min: null, max: 256 } } ],
      disabled: false,
      omitted: false
    },
    {
      id: 'cta',
      name: 'CTA',
      type: 'Array',
      localized: false,
      required: false,
      validations: [
        {
          size: { min: 0, max: 2 },
          message: 'You can only add up to 2 '
        }
      ],
      disabled: false,
      omitted: false,
      items: {
        type: 'Link',
        validations: [ { linkContentType: [ 'link' ] } ],
        linkType: 'Entry'
      }
    },
    {
      id: 'reverse',
      name: 'Reverse',
      type: 'Boolean',
      localized: false,
      required: false,
      validations: [],
      disabled: false,
      omitted: false
    },
    {
      id: 'bodyText',
      name: 'Body',
      type: 'Text',
      localized: true,
      required: true,
      validations: [],
      disabled: false,
      omitted: false
    },
    {
      id: 'img',
      name: 'Image',
      type: 'Link',
      localized: false,
      required: true,
      validations: [],
      disabled: false,
      omitted: false,
      linkType: 'Asset'
    }
  ],
  sys: {
    id: 'textAndImageBlock',
    version: 48,
    updatedAt: '2023-08-03T14:40:24.305Z'
  }
};
export default textAndImageBlock;